export const MAX_FINANCING_DAYS_ALLOWED = 180;

export const DTE_TYPES = {
  creditNote: '61',
  debitNote: '56',
  payment: '3',
};

export const RISK_STATUS = {
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  RED: 'RED',
  PENDING: 'PENDING',
  NOT_REQUIRED: 'NOT_REQUIRED',
};

export const APPROVED_PAYMENT_API_CODES = ['5', '9'];

export const LIGHTNING_PAYMENT_STATE = {
  NONE: 'NONE',
  STANDARD: 'STANDARD',
  BCI: 'BCI',
};

export const FAST_PAYMENT_APROVED_STATES = [
  LIGHTNING_PAYMENT_STATE.STANDARD,
  LIGHTNING_PAYMENT_STATE.BCI,
];

export const NOT_STATNDARD_APPROVED_STATES = [
  LIGHTNING_PAYMENT_STATE.BCI,
];
